import { render, staticRenderFns } from "./PainCard.vue?vue&type=template&id=27d2cbdc&scoped=true&"
import script from "./PainCard.vue?vue&type=script&lang=js&"
export * from "./PainCard.vue?vue&type=script&lang=js&"
import style0 from "./PainCard.vue?vue&type=style&index=0&id=27d2cbdc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d2cbdc",
  null
  
)

export default component.exports